/**
 * @module Attributes
 */
const { SUPPORTED_ATTRIBUTES } = require('../constants');

/**
 * Convenience function to iterate over and filter out unsupported element attributes from the provided attributes object for the associated element type.
 *
 * @param {object} params - The function params object.
 * @param {object} params.attributes - Object of attributes to be filtered that are associated with the element.
 * @param {string} params.elementType - String value of the element type (e.g. 'button', 'div', 'input', etc).
 *
 * @returns {object} Filtered object of supported elements for the specified element type.
 */
function filterAttributesForElement({ attributes, elementType } = {}) {
  if (!attributes || typeof attributes !== 'object') {
    return {};
  }
  if (!elementType) {
    return attributes;
  }

  const filteredAttributes = {};
  if (!Object.keys(SUPPORTED_ATTRIBUTES).includes(elementType)) {
    Object.entries(attributes).forEach(([attr, value]) => {
      if (
        attr.startsWith('aria-') ||
        attr.startsWith('data-') ||
        attr.startsWith('on') ||
        SUPPORTED_ATTRIBUTES.global.includes(attr)
      ) {
        filteredAttributes[attr] = value;
      }
    });
  } else {
    Object.entries(attributes).forEach(([attr, value]) => {
      if (
        attr.startsWith('aria-') ||
        attr.startsWith('data-') ||
        attr.startsWith('on') ||
        SUPPORTED_ATTRIBUTES.global.includes(attr) ||
        SUPPORTED_ATTRIBUTES[elementType].includes(attr)
      ) {
        filteredAttributes[attr] = value;
      }
    });
  }

  return filteredAttributes;
}

module.exports = {
  filterAttributesForElement,
};
